import useClipboard from 'vue-clipboard3'
const { toClipboard } = useClipboard()
import { ElMessage } from 'element-plus'

async function copy(para) {
  await toClipboard(para)
  ElMessage({
    message: 'Copy success!',
    type: 'success',
    showClose: true,
  })
}

function number_format(number, decimals, dec_point, thousands_sep) {
  // if (!decimals) decimals = 4
  if (!dec_point) dec_point = '.'
  if (!thousands_sep) thousands_sep = ','

  number = parseFloat(number).toFixed(6)
  number = Math.floor(number * 10000) / 10000

  number = (number + '').replace(/[^0-9+-Ee.]/g, '')
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
    dec = typeof dec_point === 'undefined' ? '.' : dec_point,
    s = '',
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return '' + parseInt(n * k) / k // Math.ceil(n * k) / k
    }

  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
  var re = /(-?\d+)(\d{3})/
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, '$1' + sep + '$2')
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }
  return s.join(dec)
}

const randomNum = (m, n) => {
  m = parseInt(m)
  n = parseInt(n + 1)
  return Math.floor(Math.random() * (n - m)) + m
}

function shortAddress(str, start_length, end_length) {
  if (!str) return
  if (str.length < start_length + end_length) return str
  return str.slice(0, start_length) + ' ... ' + str.slice(-end_length)
}

export { copy, number_format, randomNum, shortAddress }
